import {getVehicleSerialNumberType, VehicleSerialNumberType} from '@portal-workspace/grow-shared-library';

const vehicleSerialNumberTypeOptions: VehicleSerialNumberType[] = getVehicleSerialNumberType();

export type PpsrAssetComponentEvent  = PpsrAssetComponentAddEvent | PpsrAssetComponentRemoveEvent | PpsrAssetComponentSearchEvent;

export interface PpsrAssetComponentAddEvent {
  type: 'Add'
}

export interface PpsrAssetComponentRemoveEvent {
  type: 'Remove'
}

export interface PpsrAssetComponentSearchEvent {
  type: 'Search',
  serialNumberType: string,
  serialNumber: string,
}

let KEY = 1;
